import {
  iconButtonClasses,
  inputAdornmentClasses,
  inputBaseClasses,
  outlinedInputClasses,
  selectClasses,
  svgIconClasses,
} from '@mui/material';
import type { Components } from '@mui/material/styles';
import { KeyboardArrowDownRounded } from '@mui/icons-material';

import {
  fontSizeLarge,
  fontSizeMedium,
  fontSizeSmall,
  fontSizeXSmall,
  iconSizeLarge,
  iconSizeMedium,
  iconSizeSmall,
  iconSizeXSmall,
  largeSize,
  mediumSize,
  smallSize,
  xSmallSize,
} from '@/mui/components/constants';

import { GeneralSizeProp } from '@/mui/types';

const fontSizes = {
  xSmall: fontSizeXSmall,
  small: fontSizeSmall,
  medium: fontSizeMedium,
  large: fontSizeLarge,
};

const sizes = {
  xSmall: xSmallSize,
  small: smallSize,
  medium: mediumSize,
  large: largeSize,
};

const iconSizes = {
  xSmall: iconSizeXSmall,
  small: iconSizeSmall,
  medium: iconSizeMedium,
  large: iconSizeLarge,
};

const paddingSizes = {
  xSmall: [4, 4],
  small: [6.5, 6],
  medium: [8, 8],
  large: [11, 11],
};

export default function MUITextField(): Components['MuiTextField'] {
  return {
    defaultProps: {
      fullWidth: true,
      slotProps: {
        select: {
          IconComponent: KeyboardArrowDownRounded,
        },
      },
    },
    variants: [
      {
        props: { margin: 'none' },
        style: {
          [`.${inputBaseClasses.input}`]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
          [`.${outlinedInputClasses.root}`]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      },
      ...Object.keys(fontSizes).map((size) => {
        const inputSize = sizes[size as keyof typeof sizes];
        const iconSize = iconSizes[size as keyof typeof iconSizes];
        const [mPTop, mPBottom] = paddingSizes[size as keyof typeof paddingSizes];
        const fontSize = fontSizes[size as keyof typeof fontSizes];

        return {
          props: { size: size as GeneralSizeProp },
          style: {
            fontSize,
            [`& .${selectClasses.icon}`]: {
              fontSize: iconSize,
            },
            [`& .${inputBaseClasses.root}`]: {
              fontSize,
              paddingTop: 0,
              paddingBottom: 0,
              minHeight: inputSize,
            },
            [`& .${iconButtonClasses.root}`]: {
              fontSize: iconSize,
              width: inputSize,
              height: inputSize,
            },
            [` .${inputAdornmentClasses.root}`]: {
              fontSize: iconSize,
              minHeight: inputSize,

              [`& > .${svgIconClasses.root}`]: {
                fontSize: iconSize,
                minWidth: inputSize,
              },
            },
            [` .${outlinedInputClasses.notchedOutline}`]: {
              fontSize,
            },
            [` .${inputBaseClasses.input}`]: {
              fontSize,
              height: inputSize,
            },
            [`& .${inputBaseClasses.inputMultiline}`]: {
              marginTop: mPTop,
              marginBottom: mPBottom,
            },
          },
        };
      }),
    ],
    styleOverrides: {
      root: {
        position: 'relative',

        '&:before': {
          left: 4,
          right: 4,
        },

        '&:after': {
          left: 4,
          right: 4,
        },
      },
    },
  };
}
